import React, { createContext, useContext, useState, useEffect } from "react";

const STORAGE_KEY = "auditoria.data";

const AuditoriaContext = createContext(null);

export const AuditoriaProvider = ({ children }) => {
  const getInitialState = () => {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored
      ? {
          selectedDate: new Date(JSON.parse(stored).selectedDate),
          selectedClinica: JSON.parse(stored).selectedClinica,
          selectedOdontologo: JSON.parse(stored).selectedOdontologo,
          selectedListaHonorarios: JSON.parse(stored).selectedListaHonorarios,
          selectedRow: JSON.parse(stored).selectedRow,
          fotoUrl: JSON.parse(stored).fotoUrl || null,
          odontologosLista: JSON.parse(stored).odontologosLista || [],
          auditingRows: JSON.parse(stored).auditingRows || [],
          filteredAuditingRows: JSON.parse(stored).filteredAuditingRows || [],
          selectedLiquidacionRows:
            JSON.parse(stored).selectedLiquidacionRows || [],
          liquidacionRows: JSON.parse(stored).liquidacionRows || [],
          pacienteid: JSON.parse(stored).pacienteid || null,
          pacienteNombre: JSON.parse(stored).pacienteNombre || null,
          pacienteDocumento: JSON.parse(stored).pacienteDocumento || null,
          liquidandoNombre: JSON.parse(stored).liquidandoNombre || null,
          filtroPrestaciones: JSON.parse(stored).filtroPrestaciones || "Todos",
          loading: false,
          searchingResumen: false,
          searchingResumenLiquidaciones: false,
          auditingOdontologo: false,
          liquidandoOdontologo: false,
          auditingPaciente: false,
          addingPeriodo: false,
          auditoriaPantalla: JSON.parse(stored).auditoriaPantalla || null,
          auditoriaActivaId: JSON.parse(stored).auditoriaActivaId,
          auditoriaActivaFecha: JSON.parse(stored).auditoriaActivaFecha
            ? new Date(JSON.parse(stored).auditoriaActivaFecha)
            : undefined,
          modoAuditoria: JSON.parse(stored).modoAuditoria || false,
          periodoCerrado: JSON.parse(stored).periodoCerrado || false,
          page: JSON.parse(stored).page || 0,
          selectionModel: JSON.parse(stored).selectionModel || [],
        }
      : {
          selectedDate: new Date(),
          selectedClinica: null,
          selectedOdontologo: null,
          selectedListaHonorarios: null,
          selectedRow: null,
          fotoUrl: null,
          odontologosLista: [],
          auditingRows: [],
          filteredAuditingRows: [],
          selectedLiquidacionRows: [],
          liquidacionRows: [],
          filtroPrestaciones: "Todos",
          pacienteid: null,
          pacienteNombre: null,
          pacienteDocumento: null,
          auditoriaPantalla: null,
          auditoriaActivaId: null,
          auditoriaActivaFecha: null,
          loading: false,
          searchingResumen: false,
          searchingResumenLiquidaciones: false,
          auditingOdontologo: false,
          liquidandoOdontologo: false,
          liquidandoNombre: null,
          auditingPaciente: false,
          addingPeriodo: false,
          modoAuditoria: false,
          periodoCerrado: false,
          page: 0,
          selectionModel: [],
        };
  };

  const [state, setState] = useState({
    ...getInitialState(),
    prestacionesRelacionadas: [], // ← NUEVO estado no persistente
  });

  // Persistir solo los campos del estado original (sin prestacionesRelacionadas)
  useEffect(() => {
    const {
      prestacionesRelacionadas, // excluido del guardado
      ...stateToPersist
    } = state;
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stateToPersist));
  }, [state]);

  const updateAuditoria = (updates) => {
    setState((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  const resetAuditoria = () => {
    const reset = {
      loading: false,
      searchingResumen: false,
      searchingResumenLiquidaciones: false,
      auditingOdontologo: false,
      liquidandoOdontologo: false,
      liquidandoNombre: null,
      auditingPaciente: false,
      addingPeriodo: false,
      selectedDate: new Date(),
      selectedClinica: null,
      selectedOdontologo: null,
      selectedListaHonorarios: null,
      selectedRow: null,
      fotoUrl: null,
      odontologosLista: [],
      auditoriaPantalla: null,
      auditoriaActivaId: null,
      auditoriaActivaFecha: null,
      auditingRows: [],
      filteredAuditingRows: [],
      selectedLiquidacionRows: [],
      liquidacionRows: [],
      filtroPrestaciones: "Todos",
      pacienteid: null,
      pacienteDocumento: null,
      pacienteNombre: null,
      modoAuditoria: false,
      periodoCerrado: false,
      page: 0,
      selectionModel: [],
      prestacionesRelacionadas: [], // ← aseguramos que también se limpie
    };
    setState(reset);
    sessionStorage.removeItem(STORAGE_KEY);
  };

  return (
    <AuditoriaContext.Provider
      value={{
        ...state,
        updateAuditoria,
        resetAuditoria,
      }}
    >
      {children}
    </AuditoriaContext.Provider>
  );
};

export const useAuditoria = () => {
  const context = useContext(AuditoriaContext);
  if (!context) {
    throw new Error("useAuditoria debe usarse dentro de <AuditoriaProvider>");
  }
  return context;
};
